const prefix = "LEVY_COLLECTION_";

export const ADD_WIDGET = prefix + "ADD_WIDGET";
export const CREATE_FAILED = prefix + "CREATE_FAILED";
export const CREATE_INITIALISE = prefix + "CREATE_INITIALISE";
export const CREATE_STARTED = prefix + "CREATE_STARTED";
export const CREATE_SUCCEEDED = prefix + "CREATE_SUCCEEDED";
export const CREATE_TYPE = prefix + "CREATE_TYPE";
export const EDIT_DATA_SOURCE_CONFIGURATION_GET_FAILED = prefix + "EDIT_DATA_SOURCE_CONFIGURATION_GET_FAILED";
export const EDIT_DATA_SOURCE_CONFIGURATION_GET_STARTED = prefix + "EDIT_DATA_SOURCE_CONFIGURATION_GET_STARTED";
export const EDIT_DATA_SOURCE_CONFIGURATION_GET_SUCCEEDED = prefix + "EDIT_DATA_SOURCE_CONFIGURATION_GET_SUCCEEDED";
export const EDIT_DATA_SOURCE_CONFIGURATION_SAVE_FAILED = prefix + "EDIT_DATA_SOURCE_CONFIGURATION_SAVE_FAILED";
export const EDIT_DATA_SOURCE_CONFIGURATION_SAVE_STARTED = prefix + "EDIT_DATA_SOURCE_CONFIGURATION_SAVE_STARTED";
export const EDIT_DATA_SOURCE_CONFIGURATION_SAVE_SUCCEEDED = prefix + "EDIT_DATA_SOURCE_CONFIGURATION_SAVE_SUCCEEDED";
export const EDIT_DATA_SOURCE_CONFIGURATION_SET_DATA = prefix + "EDIT_DATA_SOURCE_CONFIGURATION_SET_DATA";
export const EDIT_EMAIL_CONFIGURATION_GET_FAILED = prefix + "EDIT_EMAIL_CONFIGURATION_GET_FAILED";
export const EDIT_EMAIL_CONFIGURATION_GET_STARTED = prefix + "EDIT_EMAIL_CONFIGURATION_GET_STARTED";
export const EDIT_EMAIL_CONFIGURATION_GET_SUCCEEDED = prefix + "EDIT_EMAIL_CONFIGURATION_GET_SUCCEEDED";
export const EDIT_EMAIL_CONFIGURATION_SAVE_FAILED = prefix + "EDIT_EMAIL_CONFIGURATION_SAVE_FAILED";
export const EDIT_EMAIL_CONFIGURATION_SAVE_STARTED = prefix + "EDIT_EMAIL_CONFIGURATION_SAVE_STARTED";
export const EDIT_EMAIL_CONFIGURATION_SAVE_SUCCEEDED = prefix + "EDIT_EMAIL_CONFIGURATION_SAVE_SUCCEEDED";
export const EDIT_EMAIL_CONFIGURATION_SET_DATA = prefix + "EDIT_EMAIL_CONFIGURATION_SET_DATA";
export const EDIT_FEES_GET_FAILED = prefix + "EDIT_FEES_GET_FAILED";
export const EDIT_FEES_GET_STARTED = prefix + "EDIT_FEES_GET_STARTED";
export const EDIT_FEES_GET_SUCCEEDED = prefix + "EDIT_FEES_GET_SUCCEEDED";
export const EDIT_FEES_SAVE_FAILED = prefix + "EDIT_FEES_SAVE_FAILED";
export const EDIT_FEES_SAVE_STARTED = prefix + "EDIT_FEES_SAVE_STARTED";
export const EDIT_FEES_SAVE_SUCCEEDED = prefix + "EDIT_FEES_SAVE_SUCCEEDED";
export const EDIT_FEES_SET_DATA = prefix + "EDIT_FEES_SET_DATA";
export const EDIT_INFORMATION_SESSION_DELETE_FAILED = prefix + "EDIT_INFORMATION_SESSION_DELETE_FAILED";
export const EDIT_INFORMATION_SESSION_DELETE_STARTED = prefix + "EDIT_INFORMATION_SESSION_DELETE_STARTED";
export const EDIT_INFORMATION_SESSION_DELETE_SUCCEEDED = prefix + "EDIT_INFORMATION_SESSION_DELETE_SUCCEEDED";
export const EDIT_INFORMATION_SESSION_GET_FAILED = prefix + "EDIT_INFORMATION_SESSION_GET_FAILED";
export const EDIT_INFORMATION_SESSION_GET_STARTED = prefix + "EDIT_INFORMATION_SESSION_GET_STARTED";
export const EDIT_INFORMATION_SESSION_GET_SUCCEEDED = prefix + "EDIT_INFORMATION_SESSION_GET_SUCCEEDED";
export const EDIT_INFORMATION_SESSION_INITIALISE = prefix + "EDIT_INFORMATION_SESSION_INITIALISE";
export const EDIT_INFORMATION_SESSION_SAVE_FAILED = prefix + "EDIT_INFORMATION_SESSION_SAVE_FAILED";
export const EDIT_INFORMATION_SESSION_SAVE_STARTED = prefix + "EDIT_INFORMATION_SESSION_SAVE_STARTED";
export const EDIT_INFORMATION_SESSION_SAVE_SUCCEEDED = prefix + "EDIT_INFORMATION_SESSION_SAVE_SUCCEEDED";
export const EDIT_INFORMATION_SESSION_SET_DATA = prefix + "EDIT_INFORMATION_SESSION_SET_DATA";
export const EDIT_INVOICE_CONFIGURATION_GET_FAILED = prefix + "EDIT_INVOICE_CONFIGURATION_GET_FAILED";
export const EDIT_INVOICE_CONFIGURATION_GET_STARTED = prefix + "EDIT_INVOICE_CONFIGURATION_GET_STARTED";
export const EDIT_INVOICE_CONFIGURATION_GET_SUCCEEDED = prefix + "EDIT_INVOICE_CONFIGURATION_GET_SUCCEEDED";
export const EDIT_INVOICE_CONFIGURATION_SAVE_FAILED = prefix + "EDIT_INVOICE_CONFIGURATION_SAVE_FAILED";
export const EDIT_INVOICE_CONFIGURATION_SAVE_STARTED = prefix + "EDIT_INVOICE_CONFIGURATION_SAVE_STARTED";
export const EDIT_INVOICE_CONFIGURATION_SAVE_SUCCEEDED = prefix + "EDIT_INVOICE_CONFIGURATION_SAVE_SUCCEEDED";
export const EDIT_INVOICE_CONFIGURATION_SET_DATA = prefix + "EDIT_INVOICE_CONFIGURATION_SET_DATA";
export const EDIT_INVOICING_TIMING_CONFIGURATION_GET_FAILED = prefix + "EDIT_INVOICING_TIMING_CONFIGURATION_GET_FAILED";
export const EDIT_INVOICING_TIMING_CONFIGURATION_GET_STARTED =
  prefix + "EDIT_INVOICING_TIMING_CONFIGURATION_GET_STARTED";
export const EDIT_INVOICING_TIMING_CONFIGURATION_GET_SUCCEEDED =
  prefix + "EDIT_INVOICING_TIMING_CONFIGURATION_GET_SUCCEEDED";
export const EDIT_INVOICING_TIMING_CONFIGURATION_SAVE_FAILED =
  prefix + "EDIT_INVOICING_TIMING_CONFIGURATION_SAVE_FAILED";
export const EDIT_INVOICING_TIMING_CONFIGURATION_SAVE_STARTED =
  prefix + "EDIT_INVOICING_TIMING_CONFIGURATION_SAVE_STARTED";
export const EDIT_INVOICING_TIMING_CONFIGURATION_SAVE_SUCCEEDED =
  prefix + "EDIT_INVOICING_TIMING_CONFIGURATION_SAVE_SUCCEEDED";
export const EDIT_INVOICING_TIMING_CONFIGURATION_SET_DATA = prefix + "EDIT_INVOICING_TIMING_CONFIGURATION_SET_DATA";
export const EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_GET_FAILED =
  prefix + "EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_GET_FAILED";
export const EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_GET_STARTED =
  prefix + "EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_GET_STARTED";
export const EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_GET_SUCCEEDED =
  prefix + "EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_GET_SUCCEEDED";
export const EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_SAVE_FAILED =
  prefix + "EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_SAVE_FAILED";
export const EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_SAVE_STARTED =
  prefix + "EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_SAVE_STARTED";
export const EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_SAVE_SUCCEEDED =
  prefix + "EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_SAVE_SUCCEEDED";
export const EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_SET_DATA =
  prefix + "EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_SET_DATA";
export const EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_GET_FAILED =
  prefix + "EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_GET_FAILED";
export const EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_GET_STARTED =
  prefix + "EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_GET_STARTED";
export const EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_GET_SUCCEEDED =
  prefix + "EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_GET_SUCCEEDED";
export const EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_SAVE_FAILED =
  prefix + "EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_SAVE_FAILED";
export const EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_SAVE_STARTED =
  prefix + "EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_SAVE_STARTED";
export const EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_SAVE_SUCCEEDED =
  prefix + "EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_SAVE_SUCCEEDED";
export const EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_SET_DATA =
  prefix + "EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_SET_DATA";
export const EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SET_DATA =
  prefix + "EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SET_DATA";
export const EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_GET_FAILED =
  prefix + "EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_GET_FAILED";
export const EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_GET_STARTED =
  prefix + "EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_GET_STARTED";
export const EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_GET_SUCCEEDED =
  prefix + "EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_GET_SUCCEEDED";
export const EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SAVE_FAILED =
  prefix + "EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SAVE_FAILED";
export const EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SAVE_STARTED =
  prefix + "EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SAVE_STARTED";
export const EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SAVE_SUCCEEDED =
  prefix + "EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SAVE_SUCCEEDED";
export const EDIT_SET_DATA = prefix + "EDIT_SET_DATA";
export const FINISH_SETUP_FAILED = prefix + "FINISH_SETUP_FAILED";
export const FINISH_SETUP_STARTED = prefix + "FINISH_SETUP_STARTED";
export const FINISH_SETUP_SUCCEEDED = prefix + "FINISH_SETUP_SUCCEEDED";
export const GET_COMPONENT_LEVY_AMOUNTS_FAILED = prefix + "GET_COMPONENT_LEVY_AMOUNTS_FAILED";
export const GET_COMPONENT_LEVY_AMOUNTS_STARTED = prefix + "GET_COMPONENT_LEVY_AMOUNTS_STARTED";
export const GET_COMPONENT_LEVY_AMOUNTS_SUCCEEDED = prefix + "GET_COMPONENT_LEVY_AMOUNTS_SUCCEEDED";
export const GET_PROVIDER_TASKS_FAILED = prefix + "GET_PROVIDER_TASKS_FAILED";
export const GET_PROVIDER_TASKS_STARTED = prefix + "GET_PROVIDER_TASKS_STARTED";
export const GET_PROVIDER_TASKS_SUCCEEDED = prefix + "GET_PROVIDER_TASKS_SUCCEEDED";
export const GET_STATUS_HISTORY_FAILED = prefix + "GET_STATUS_HISTORY_FAILED";
export const GET_STATUS_HISTORY_STARTED = prefix + "GET_STATUS_HISTORY_STARTED";
export const GET_STATUS_HISTORY_SUCCEEDED = prefix + "GET_STATUS_HISTORY_SUCCEEDED";
export const INVOICE_TEMPLATE_UPLOAD_FAILED = prefix + "INVOICE_TEMPLATE_UPLOAD_FAILED";
export const INVOICE_TEMPLATE_UPLOAD_STARTED = prefix + "INVOICE_TEMPLATE_UPLOAD_STARTED";
export const INVOICE_TEMPLATE_UPLOAD_SUCCEEDED = prefix + "INVOICE_TEMPLATE_UPLOAD_SUCCEEDED";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const TASK_RUN_FAILED = prefix + "TASK_RUN_FAILED";
export const TASK_RUN_STARTED = prefix + "TASK_RUN_STARTED";
export const TASK_RUN_SUCCEEDED = prefix + "TASK_RUN_SUCCEEDED";
export const TASKS_GET_FAILED = prefix + "TASKS_GET_FAILED";
export const TASKS_GET_STARTED = prefix + "TASKS_GET_STARTED";
export const TASKS_GET_SUCCEEDED = prefix + "TASKS_GET_SUCCEEDED";
export const VIEW_CLEAR = prefix + "VIEW_CLEAR";
export const VIEW_DATA_SOURCE_CONFIGURATION_FAILED = prefix + "VIEW_DATA_SOURCE_CONFIGURATION_FAILED";
export const VIEW_DATA_SOURCE_CONFIGURATION_STARTED = prefix + "VIEW_DATA_SOURCE_CONFIGURATION_STARTED";
export const VIEW_DATA_SOURCE_CONFIGURATION_SUCCEEDED = prefix + "VIEW_DATA_SOURCE_CONFIGURATION_SUCCEEDED";
export const VIEW_EMAIL_CONFIGURATION_FAILED = prefix + "VIEW_EMAIL_CONFIGURATION_FAILED";
export const VIEW_EMAIL_CONFIGURATION_STARTED = prefix + "VIEW_EMAIL_CONFIGURATION_STARTED";
export const VIEW_EMAIL_CONFIGURATION_SUCCEEDED = prefix + "VIEW_EMAIL_CONFIGURATION_SUCCEEDED";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_FEES_FAILED = prefix + "VIEW_FEES_FAILED";
export const VIEW_FEES_STARTED = prefix + "VIEW_FEES_STARTED";
export const VIEW_FEES_SUCCEEDED = prefix + "VIEW_FEES_SUCCEEDED";
export const VIEW_INFORMATION_SESSIONS_FAILED = prefix + "VIEW_INFORMATION_SESSIONS_FAILED";
export const VIEW_INFORMATION_SESSIONS_STARTED = prefix + "VIEW_INFORMATION_SESSIONS_STARTED";
export const VIEW_INFORMATION_SESSIONS_SUCCEEDED = prefix + "VIEW_INFORMATION_SESSIONS_SUCCEEDED";
export const VIEW_INVOICE_CONFIGURATION_FAILED = prefix + "VIEW_INVOICE_CONFIGURATION_FAILED";
export const VIEW_INVOICE_CONFIGURATION_STARTED = prefix + "VIEW_INVOICE_CONFIGURATION_STARTED";
export const VIEW_INVOICE_CONFIGURATION_SUCCEEDED = prefix + "VIEW_INVOICE_CONFIGURATION_SUCCEEDED";
export const VIEW_INVOICING_TIMING_CONFIGURATION_FAILED = prefix + "VIEW_INVOICING_TIMING_CONFIGURATION_FAILED";
export const VIEW_INVOICING_TIMING_CONFIGURATION_STARTED = prefix + "VIEW_INVOICING_TIMING_CONFIGURATION_STARTED";
export const VIEW_INVOICING_TIMING_CONFIGURATION_SUCCEEDED = prefix + "VIEW_INVOICING_TIMING_CONFIGURATION_SUCCEEDED";
export const VIEW_NON_COMPLIANCE_HISTORY_CONFIGURATION_FAILED =
  prefix + "VIEW_NON_COMPLIANCE_HISTORY_CONFIGURATION_FAILED";
export const VIEW_NON_COMPLIANCE_HISTORY_CONFIGURATION_STARTED =
  prefix + "VIEW_NON_COMPLIANCE_HISTORY_CONFIGURATION_STARTED";
export const VIEW_NON_COMPLIANCE_HISTORY_CONFIGURATION_SUCCEEDED =
  prefix + "VIEW_NON_COMPLIANCE_HISTORY_CONFIGURATION_SUCCEEDED";
export const VIEW_LEVY_CALCULATION_TIMING_CONFIGURATION_FAILED =
  prefix + "VIEW_LEVY_CALCULATION_TIMING_CONFIGURATION_FAILED";
export const VIEW_LEVY_CALCULATION_TIMING_CONFIGURATION_STARTED =
  prefix + "VIEW_LEVY_CALCULATION_TIMING_CONFIGURATION_STARTED";
export const VIEW_LEVY_CALCULATION_TIMING_CONFIGURATION_SUCCEEDED =
  prefix + "VIEW_LEVY_CALCULATION_TIMING_CONFIGURATION_SUCCEEDED";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
